/* ============================================================
   upsell-panier.js
   Moteur du bloc « Fréquemment achetés ensemble » du panier.
   En général tu n'as PAS besoin de toucher ce fichier :
   tout ce qui est visuel/éditorial est dans snippets/upsell-panier.liquid
   ============================================================ */
(function () {
  if (window.__upsellPanierBound) return;
  window.__upsellPanierBound = true;

  function cartAddUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.upsell-row__btn');
    if (!btn || btn.disabled) return;
    evt.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        var row = btn.closest('.upsell-row');
        if (row) {
          row.classList.add('upsell-row--error');
          setTimeout(function () { row.classList.remove('upsell-row--error'); }, 2500);
        }
      });
  });
})();
